import { Text } from './Text'

/**
 * Stage indicator: an information-only chip that shows where the applicant is in
 * the flow. Styled button-like (rounded, inset) to sit with the CTAs beneath the
 * home feature card — it is intentionally not interactive.
 */
export function StageBar({ prefix, label }: { prefix: string; label: string }) {
  return (
    <div
      role="status"
      className="rounded-sm border border-yellow-700 bg-yellow-500 px-4 py-3"
    >
      <Text as="p" variant="sm" className="text-gray-900">
        <span className="font-semibold">{prefix}</span>
        {' · '}
        {label}
      </Text>
    </div>
  )
}
